'use client';

import { cn } from '@wwe-portal/ui/lib/lib';
import { useScrollOffset } from '@wwe-portal/web/providers/stores/layout-store';
import { ReactNode } from 'react';

export const StickyTopMenu = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  const scrollOffset = useScrollOffset();
  return (
    <div
      className={cn(
        'z-sticky data-[sticky=true]:bg-back600 sticky top-[60px] mx-[-20px] px-5 py-5 xl:top-[70px] xl:mx-[-30px] xl:px-[30px]',
        className
      )}
      data-sticky={scrollOffset && scrollOffset > 55}
    >
      {children}
    </div>
  );
};
